import * as React from 'react';
import { Content, CTCParsedOutputModel, SectionWrapperModel as InputModel } from '../../interfaces';
import { formatMoneyCTC, getCTCValues } from '../../utilities/slider';
import renderDataTest from '../../utilities/testAutomation';
import toggleAEMSibling from '../../utilities/toggleAEM';
import ContentContext from '../App/Context';
import Button from '../Button/Button';
import GlossaryTooltip from '../GlossaryTooltip/GlossaryTooltip';
import Loading from '../Loading/Loading';
import OptionSlider from '../OptionSlider/OptionSlider';
import PanelError from '../PanelError/PanelError';
import OutputsBottom from './OutputsBottom';
import { ChevronPosition } from '../Icons/Chevron/Chevron';
import { CTCOutputModel } from '../../utilities/calculator';

const Parser = require('html-react-parser');

interface Props {
  inputModel: InputModel;
  results: CTCOutputModel[] | string;
  hideOutputs: () => void;
}

interface State {
  sliderValue: number;
  sliderWrapper?: HTMLDivElement;
  summaryWrapper?: HTMLDivElement;
}

class Outputs extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = { sliderValue: 50 };
  }

  _getSummarySubstrings = (text1: string, text2: string) => {
    const splitSummary1 = text1.split('{nominalPotValue}');
    const splitSummary2 = splitSummary1[1].split('{withdrawalAge}');
    const splitSummary3 = text2.split('{realPotValue}');

    return [
      splitSummary1[0],
      splitSummary2[0],
      splitSummary2[1],
      splitSummary3[0],
      splitSummary3[1],
    ];
  }

  render() {
    const {
      inputModel: { withdrawalAge },
      results,
      hideOutputs,
    } = this.props;
    const { sliderValue } = this.state;
    const isReady = results.length > 0;
    const isSuccessful = isReady && results !== 'error';
    const { inputModel } = this.props;
    toggleAEMSibling(true);
    const ctcOutput = formatMoneyCTC(getCTCValues(sliderValue, results as CTCOutputModel[])) as CTCParsedOutputModel;
    return (
      <ContentContext.Consumer>
        {(content: Content) => {
          const {
            analytics,
            outputs: {
              error,
              summary,
              slider,
            },
          } = content;
          const [
            summarySubstring1,
            summarySubstring2,
            summarySubstring3,
            summarySubstring4,
            summarySubstring5,
          ] = this._getSummarySubstrings(summary.text1, summary.text2);

          return (
            <div className="outputs">
              <Loading show={!isReady} />
              {!isSuccessful &&
                <div className="white-section white-section--error bottom-arrow bottom-arrow--white">
                  <PanelError
                    title={error.title}
                    body={error.text}
                    button={
                      <Button
                        name={error.cta.label}
                        onClick={hideOutputs}
                        chevron={ChevronPosition.Left}
                        data-dtm-id="buttons"
                        data-dtm-data={analytics.button.edit}
                        {...renderDataTest('ppc-outputs-button-back')}
                      />}
                  />
                </div>}
              {isSuccessful &&
                <div className="white-section bottom-arrow bottom-arrow--white">
                  <div className="summary output-section">
                    <div
                      className="summary--text"
                      ref={(element: HTMLDivElement) => {
                        if (!this.state.summaryWrapper) {
                          this.setState({ summaryWrapper: element });
                        }
                      }}
                    >
                      <h4>
                        {Parser(summarySubstring1)}{' '}
                        <span
                          className="highlight"
                          {...renderDataTest('ppc-outputs-nominal-pot-value')}
                        >
                          {ctcOutput.ProjectedFund_Monetary}{' '}
                        </span>
                        {Parser(summarySubstring2)}{' '}
                        <span
                          className="highlight"
                          {...renderDataTest('ppc-outputs-withdrawal-age')}
                        >
                          {withdrawalAge}{' '}
                        </span>{' '}
                        {Parser(summarySubstring3)}{' '}
                        <GlossaryTooltip
                          term={summary.text.glossarytooltip.term}
                          content={summary.text.glossarytooltip.content}
                          parentContainer={this.state.summaryWrapper}
                          dataTest="'ppc-outputs-inflation-tooltip"
                        />{' '}
                        {Parser(summarySubstring4)}{' '}
                        <div
                          className="highlight highlight--large"
                          {...renderDataTest('ppc-outputs-real-pot-value')}
                        >
                          {ctcOutput.ProjectedFund_Real}{' '}
                        </div>{Parser(summarySubstring5)}{Parser(summary.text3)}
                      </h4>
                    </div>
                    <div
                      className="summary--slider-wrapper"
                      ref={(element: HTMLDivElement) => {
                        if (!this.state.sliderWrapper) {
                          this.setState({ sliderWrapper: element });
                        }
                      }}
                    >
                      <h3>{Parser(slider.title)}</h3>
                      <p className="info-text">
                        {Parser(slider.text1)}{' '}
                        <GlossaryTooltip
                          term={slider.text.glossarytooltip1.term}
                          content={slider.text.glossarytooltip1.content}
                          parentContainer={this.state.sliderWrapper}
                          dataTest="'ppc-outputs-todays-prices-tooltip"
                        />{' '}
                        {Parser(slider.text2)}{' '}
                        <GlossaryTooltip
                          term={slider.text.glossarytooltip2.term}
                          content={slider.text.glossarytooltip2.content}
                          parentContainer={this.state.sliderWrapper}
                          dataTest="ppc-outputs-medium-return-tooltip"
                        />{' '}
                        {Parser(slider.text3)}
                      </p>
                      <OptionSlider
                        min={0}
                        max={100}
                        step={50}
                        value={sliderValue}
                        labels={{
                          0: slider.label1,
                          50: slider.label2,
                          100: slider.label3,
                        }}
                        onChange={(value: number) => { this.setState({ sliderValue: value }); }}
                        dataTest={renderDataTest('ppc-outputs-returns-slider')}
                      />
                    </div>
                  </div>
                </div>
                }
              <OutputsBottom {...{
                isSuccessful, hideOutputs, ctcOutput, inputModel,
              }}
              />
            </div>
          );
        }}
      </ContentContext.Consumer>
    );
  }
}

export default Outputs;



// WEBPACK FOOTER //
// ./src/components/Outputs/Outputs.tsx